<template>
  <div>
    reset pass
  </div>
</template>

<script>
export default {
  name: "ResetPassword"
}
</script>

<style scoped>

</style>
